<template>
	<v-container>
		<v-app-bar app>
			<div class="d-flex d-lg-none">
				<v-app-bar-nav-icon
					@click.stop="$emit('drawer-change')"
				></v-app-bar-nav-icon>
			</div>
			<v-toolbar-title>Início</v-toolbar-title>
		</v-app-bar>
		<v-row>
			<v-col cols="3">
				<v-card tile>
					<v-card-title primary-title>
						<v-icon class="mr-2">mdi-contacts</v-icon> Parlamentares
					</v-card-title>
					<v-card-actions>
						<v-row>
							<v-col class="text-center" justify-center width="100%">
								<v-skeleton-loader
									type="image"
									height="60"
									:loading="!qtdParlamentares"
								>
									<span class="text-center display-3">{{
										qtdParlamentares
									}}</span>
									<br />
								</v-skeleton-loader>
								Qtd. de Parlamentares cadastrados
							</v-col>
						</v-row>
					</v-card-actions>
				</v-card>
			</v-col>
			<v-col></v-col>
		</v-row>
	</v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
	name: 'Home',
	data() {
		return {
			qtdParlamentares: null,
		};
	},
	components: {},
	async created() {
		this.qtdParlamentares = (
			await this.$fetch.get('parlamentares/qtd')
		).quantidade;
	},
};
</script>
